import React from 'react';

const Details: React.FC = () => {
    const events = [
        {
            icon: '💒',
            title: 'Церемония',
            time: '16:00',
            location: 'Фазенда "Николаево"',
            address: 'Витебский р-н, деревня Дрюково, ул. Центральная 32',
        },
        {
            icon: '🥂',
            title: 'Банкет',
            time: '17:00',
            location: 'Фазенда "Николаево"',
            address: 'Витебский р-н, деревня Дрюково, ул. Центральная 32',
        },
    ];

    return (
        <section className="bg-white py-24 md:py-32 px-4">
            <div className="max-w-4xl mx-auto">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-4">
                    информация
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">Детали</h2>
                <div className="flex items-center justify-center gap-3 mb-14 divider-ornament max-w-xs mx-auto">
                    <span className="text-gold text-xl animate-heart">♥</span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {events.map((event) => (
                        <div
                            key={event.title}
                            className="golden-border bg-cornsilk rounded-2xl shadow-card p-8 md:p-10 flex flex-col items-center
                                       hover:shadow-elegant transition-shadow duration-500">
                            <span className="text-4xl mb-5">{event.icon}</span>
                            <h3 className="font-serif text-xl md:text-2xl text-prussian_blue font-semibold mb-3">
                                {event.title}
                            </h3>
                            <p className="font-serif text-3xl md:text-4xl text-prussian_blue font-semibold mb-4">{event.time}</p>
                            <div className="w-8 h-px bg-dry_sage/40 mb-4" />
                            <p className="font-sans text-prussian_blue/70 text-sm md:text-base">{event.location}</p>
                            <p className="font-sans text-xs md:text-sm text-prussian_blue/40 mt-2">{event.address}</p>
                        </div>
                    ))}
                </div>

                <div className="golden-border bg-cornsilk rounded-2xl shadow-card mt-10 overflow-hidden">
                    <div className="text-center py-6">
                        <p className="font-sans text-[10px] md:text-md tracking-[0.4em] uppercase text-dry_sage mb-2">
                            📍 как добраться
                        </p>
                        <p className="font-sans text-xs text-prussian_blue/40">
                            Фазенда «Николаево» — Витебский р-н, деревня Дрюково
                        </p>
                    </div>
                    <div className="w-full aspect-[16/9] md:aspect-[4/3]">
                        <iframe
                            className="w-full h-full border-0"
                            src="https://yandex.ru/map-widget/v1/?um=constructor%3A46c860c75384c2ee43b1d3542c73833b460c8cfab2b8da644532392d6426b4b2&amp;source=constructor"
                            title="Карта — место проведения свадьбы"
                            allowFullScreen
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Details;

